import { type ReactNode, type FC } from 'react';
import { AiTutorAndContactUs } from './AiTutorAndContactUs';
import { ContactUs } from './ContactUs';

export const SupportModalBody: FC<{ AiTutorComponent?: ReactNode | null; onlyAiTutor?: boolean }> = ({
    AiTutorComponent,
    onlyAiTutor,
}) =>
    onlyAiTutor && AiTutorComponent ? (
        AiTutorComponent
    ) : AiTutorComponent ? (
        <AiTutorAndContactUs AiTutorComponent={AiTutorComponent} />
    ) : (
        <ContactUs />
    );
